/* eslint-disable */

import { NavLink, useLocation } from "react-router-dom";
import {
  Box,
  Flex,
  HStack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { useSidebar } from "contexts/SidebarContext";

function routeHref(route: RoutesType) {
  const p = String(route.path).replace(/^\//, "");
  return `${route.layout}/${p}`.replace(/\/+/g, "/");
}

export function SidebarLinks(props: { routes: RoutesType[] }) {
  const { sidebarCollapsed } = useSidebar();
  const location = useLocation();
  const activeColor = useColorModeValue("gray.700", "white");
  const inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  const activeIcon = useColorModeValue("brand.500", "white");
  const textColor = useColorModeValue("secondaryGray.500", "white");
  const brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes } = props;

  const activeRoute = (routePath: string) => {
    const normalized = routePath.replace(/^\//, "");
    return location.pathname.includes(normalized);
  };

  const createLinks = (routeList: RoutesType[]) => {
    return routeList.map((route: RoutesType, index: number) => {
      if (route.hidden) return null;
      if (
        route.layout === "/partner" ||
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        const href = routeHref(route);
        const linkBody = route.icon ? (
          <Box>
            <HStack
              spacing={sidebarCollapsed ? "0px" : activeRoute(route.path) ? "22px" : "26px"}
              py="8px"
              ps={sidebarCollapsed ? "4px" : "10px"}
              pe={sidebarCollapsed ? "4px" : "0px"}
              justify={sidebarCollapsed ? "center" : "flex-start"}
            >
              <Flex
                w={sidebarCollapsed ? "auto" : "100%"}
                alignItems="center"
                justifyContent={sidebarCollapsed ? "center" : "center"}
                position="relative"
              >
                <Flex
                  display="flex"
                  align="center"
                  justify="center"
                  color={
                    activeRoute(route.path) ? activeIcon : textColor
                  }
                  me={sidebarCollapsed ? "0" : "18px"}
                  sx={{
                    "& svg": { display: "flex" },
                  }}
                >
                  {route.icon}
                </Flex>
                {!sidebarCollapsed ? (
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path) ? activeColor : textColor
                    }
                    fontWeight={
                      activeRoute(route.path) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                ) : null}
              </Flex>
              {!sidebarCollapsed ? (
                <Box
                  h="36px"
                  w="4px"
                  bg={
                    activeRoute(route.path) ? brandColor : "transparent"
                  }
                  borderRadius="5px"
                  flexShrink={0}
                />
              ) : null}
            </HStack>
          </Box>
        ) : null;

        return (
          <NavLink key={index} to={href}>
            {route.icon ? (
              sidebarCollapsed ? (
                <Tooltip
                  label={route.name}
                  placement="right"
                  hasArrow
                  openDelay={400}
                >
                  <Box position="relative">{linkBody}</Box>
                </Tooltip>
              ) : (
                linkBody
              )
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path) ? activeColor : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
      return null;
    });
  };

  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
